import { getAuthHeaders } from './authActions'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

const fetchWithAuth = async (endpoint, options = {}) => {
	const res = await fetch(`${BASE_URL}${endpoint}`, {
		method: 'GET',
		headers: {
			...getAuthHeaders(),
			...(options.headers || {}),
		},
		...options,
	})

	if (!res.ok) {
		const message = await res.text()
		throw new Error(message || 'Request failed')
	}

	return res.json()
}

export const getOrgUsers = (orgSlug) =>
	fetchWithAuth(`/api/org/${orgSlug}/org-users`)

export const getOrgExperiences = (orgSlug) =>
	fetchWithAuth(`/api/org/${orgSlug}/org-experiences`)
